module.exports = __webpack_public_path__ + "src/routes/home/banner.svg?72bfa636";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/banner.svg
// module id = 2850
// module chunks = 1